export default class ConfigurationModel{
    #authConfig;
    #config;
    #details;
    #images;
    #links;
    #routes;
    #tenant;
    #tenantId;
    #vendors;
    #theme;
    //b2b
    #acuity;
    #courses;
    #competitions;
    #personas;
    #resources;
    #email_dictionary;
    #ov_proxy_service;
    #slack;
    #user_email_dictionary;
    #tags;
    #viewables;
    constructor( configuration ){
        this.loadConfiguration( configuration );
    }

    //B2B
    getAcuityKey(){
        return this.#acuity;
    }

    getAllTenantImages(){
        return Object.freeze( this.#images );
    }

    getAppType(){
        return this.#config.ACTIVE_TENANT_ID === 2 ? "passport" : "os";
    }

    getAuthConfig(){
        return Object.freeze( this.#authConfig );
    }

    getAuthConfigClientId(){
        return this.#authConfig.clientId;
    }

    getAuthConfigDetails( redirect_uri = "" ){
        const { authConfig } = this.#authConfig;
        const { origin, pathname, search } = window.location;
        const appStateTarget = `${ pathname }${ search }`;

        authConfig.authorizationParams = {
            ...authConfig.authorizationParams,
            appState: { target: appStateTarget },
            redirect_uri: redirect_uri || origin
        };

        return authConfig;
    }

    getCompetitionsConfig( key = false ){
        return key ? this.#competitions[key] : this.#competitions;
    }

    getPersonaMap(){
        return this.#personas;
    }

    getResourcesConfig(){
        return this.#resources;
    }

    getSiteConfig(){
        return Object.freeze( this.#config );
    }

    getSiteConfigByKey( configKey, key = false ){
        return key ? this.#config[configKey][key] : this.#config[configKey];
    }

    getSKey(){
        return this.#config?.S_KEY || "";
    }

    getTenantCourses(){
        return this.#courses;
    }

    getTenantDetails(){
        return Object.freeze( this.#details );
    }

    getTenantDetailsByKey( configKey, key = false ){
        if ( !this.#details[configKey] ){
            return;
        }

        return key ? this.#details[configKey][key] : this.#details[configKey];
    }

    getTenantEmailDictionary(){
        return this.#email_dictionary;
    }

    getTenantId(){
        return this.#tenantId;
    }

    getTenantImageByKey( key ){
        return this.#images[key];
    }

    getTenantLinks(){
        return Object.freeze( this.#links );
    }

    getTenantName(){
        return this.#tenant;
    }

    getTenantOvProxyService(){
        return this.#ov_proxy_service;
    }

    getTenantRoutes(){
        return Object.freeze( this.#routes );
    }

    getTenantSlack(){
        return this.#slack;
    }

    getTenantTags(){
        return this.#tags;
    }

    getTenantUserEmailDictionary(){
        return this.#user_email_dictionary;
    }

    getTheme(){
        return this.#theme;
    }

    getVendorKey( key ){
        if ( this.#vendors?.[key] ){
            return this.#vendors[key];
        }
    }

    getViewable(){
        return this.#viewables;
    }

    loadConfiguration( configuration ){
        const {
            AUTH_CONFIG,
            CONFIG,
            DETAILS,
            IMAGES,
            LINKS,
            ROUTES,
            TENANT,
            TENANT_ID,
            THEME,
            VENDORS,
            //b2b
            ACUITY,
            COURSES,
            COMPETITIONS,
            EMAIL_DICTIONARY,
            OV_PROXY_SERVICE,
            PERSONAS,
            RESOURCES,
            SLACK,
            TAGS,
            USER_EMAIL_DICTIONARY,
            VIEWABLES
        } = configuration;

        this.#authConfig = AUTH_CONFIG ?? {};
        this.#config = CONFIG ?? {};
        this.#details = DETAILS ?? {};
        this.#images = IMAGES ?? {};
        this.#links = LINKS ?? {};
        this.#routes = ROUTES ?? {};
        this.#tenant = TENANT ?? "";
        this.#tenantId = TENANT_ID ?? "";
        this.#vendors = VENDORS ?? "";
        this.#theme = THEME ?? {};
        //B2B
        this.#acuity = ACUITY ?? "";
        this.#courses = COURSES ?? {};
        this.#competitions = COMPETITIONS ?? {};
        this.#personas = PERSONAS ?? {};
        this.#resources = RESOURCES ?? {};

        this.#email_dictionary = EMAIL_DICTIONARY ?? {};
        this.#ov_proxy_service = OV_PROXY_SERVICE ?? {};
        this.#slack = SLACK ?? {};
        this.#user_email_dictionary = USER_EMAIL_DICTIONARY ?? {};
        this.#tags = TAGS ?? {};
        this.#viewables = VIEWABLES ?? {};
    }
}